import { createI18n } from 'vue-i18n'
import messages from '../translations/main.js'
import languages from '@/utils/supportedLanguages.js'

const urlParams = new URLSearchParams(window.location.search)
const queriedLanguage = urlParams.get('language')
let currentLang = 'en'

if (queriedLanguage in languages) {
  currentLang = queriedLanguage
}

const i18n = createI18n({
  legacy: false,
  locale: currentLang,
  ...messages,
})

export default i18n